import { isBefore, addYears } from 'date-fns';
import { isValidPhoneNumber } from 'libphonenumber-js';
import * as Yup from 'yup';
import { EMAIL_REGEX, COUNTRY, FISCAL_CODE_REGEX } from '../../../../../constants';

export const wizardSellerSchema = Yup.object({
  name: Yup
    .string()
    .trim()
    .test(
      'containsSpaces',
      'Inserisci il nome completo',
      (value) => !value || value.includes(' '),
    ),
  email: Yup
    .string()
    .test(
      'validEmail',
      'Inserisci una email valida',
      (value) => !value || EMAIL_REGEX.test(value),
    ),
  phoneNumber: Yup
    .string()
    .test(
      'isValid',
      'Inserisci un numero di telefono valido',
      (value: string | undefined) => !value || isValidPhoneNumber(value, COUNTRY),
    ),
  fiscalCode: Yup
    .string()
    .test(
      'validFiscalCode',
      'Inserisci un codice fiscale valido',
      (value) => !value || FISCAL_CODE_REGEX.test(value),
    ),
  birthDate: Yup
    .date()
    .nullable()
    .test(
      'isAtLeast18YearsInThePast',
      'Il contatto deve essere maggiorenne',
      (value) => !value || isBefore(addYears(value, 18), new Date()),
    ),
  birthPlace: Yup
    .string(),
  address: Yup
    .object()
    .nullable()
    .optional(),
});
